import { render, staticRenderFns } from "./ModalEditResource.vue?vue&type=template&id=ca48443c&"
import script from "./ModalEditResource.vue?vue&type=script&lang=js&"
export * from "./ModalEditResource.vue?vue&type=script&lang=js&"
import style0 from "./ModalEditResource.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports